import styled from 'styled-components'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  overflow: visible;
`

export const GridContainer = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: visible;

  .ReactVirtualized__Grid,
  .ReactVirtualized__Grid__innerScrollContainer {
    overflow: visible !important;
  }
`

export const GridCell = styled.div`
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    z-index: 20;
  }
`

export const GridCellInner = styled.div`
  width: 90%;
  height: 90%;
  position: relative;
  overflow: visible;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 240px;
`

export const EmptyState = styled.p`
  margin: 0;
  padding: 1rem 0;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Chivo', sans-serif;
  font-size: 1.3rem;
`
